import { TenantClient } from 'pbts/c1/api/tenant/v1/tenant.client'
import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'

export const introspectTenantApi = createUnaryApi(
    TenantClient,
    'introspect',
)
